module.exports = __webpack_public_path__ + "media/images/about/about-image1-9b155f1fdbafa633983708625163edef.jpg";